/* dakotatin-lead-events.js
 * GA4 events for mailto: and tel: link clicks.
 * Carries the captured gclid + utm_* on the event payload so Google Ads can attribute.
 *
 * REQUIRES: dakotatin-attribution-capture.js (sets window.DTAttribution)
 *
 * AFTER INSTALL:
 *   1. In GA4, mark email_click and phone_click as Key Events
 *      (Admin > Events > toggle "Mark as key event")
 *   2. In Google Ads, both will appear under Tools > Conversions within 24-48h
 *      via the existing GA4 import. Mark them as conversions.
 *
 * Created: 2026-05-28
 * Modified: 2026-05-28
 */
(function () {
  function fire(name, href) {
    var payload = { link_url: href, page_path: location.pathname };
    var a = window.DTAttribution || {};
    ['gclid', 'utm_source', 'utm_medium', 'utm_campaign'].forEach(function (k) {
      if (a[k]) payload[k] = a[k];
    });
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, payload);
    } else if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(Object.assign({ event: name }, payload));
    }
  }

  document.addEventListener(
    'click',
    function (e) {
      var a = e.target.closest && e.target.closest('a');
      if (!a || !a.href) return;
      if (a.href.indexOf('mailto:') === 0) {
        fire('email_click', a.href);
      } else if (a.href.indexOf('tel:') === 0) {
        fire('phone_click', a.href);
      }
    },
    true
  );
})();
